/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

/**
 * This component contains a disabled input field with a button to copy the contents of the field to the clipboard
 *
 * @example
 * ```
 * copiable-input(value="text to be copied")
 *    ....
 * ```
 *
 * @category ui.components.form-elements
 * @exports CopiableInput
 * @component
 */
const __vue_script__ = {
    name: 'CopiableInput',

    components: {
        BaseInput
    },

    props: {
        name: {
            type: String,
            default: ''
        },

        label: {
            type: String,
            default: ''
        },

        hint: {
            type: String,
            default: ''
        },

        value: {
            type: String,
            required: true
        },

        placeholder: {
            type: String,
            default: ''
        },

        buttonClass: {
            type: String,
            default: 'btn-default'
        },

        hintAfterLabel: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            inputName: this.name || `copiable-input-${this._uid}`
        };
    },

    methods: {
        async copy() {
            if (!this.value) {
                return;
            }

            await this.$copyText(this.value);

            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('general.copy_success').toString(),
                type: 'success'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',{attrs:{"label":_vm.label,"type":"text","name":_vm.inputName,"readonly":"readonly","hint":_vm.hint,"hint-after-label":_vm.hintAfterLabel,"placeholder":_vm.placeholder},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('button',{staticClass:"btn",class:_vm.buttonClass,attrs:{"type":"button","disabled":!_vm.value},on:{"click":function($event){$event.preventDefault();return _vm.copy()}}},[_vm._v(_vm._s(_vm.$t('general.copy')))])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CopiableInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__